export enum CleverTapControlAction {
  RecordEvent = 'recordEvent',
}

const getCleverTapActionOptions = () => [
  {
    const: CleverTapControlAction.RecordEvent,
    title: 'Record Event',
    icon: 'SvgLineChartUp03',
    groupId: 8,
  },
];

export const getControlCleverTapSchema = () => {
  const actionOptions = getCleverTapActionOptions();

  return {
    type: 'object',
    properties: {
      operation: {
        type: 'string',
        title: 'Operation',
        default: CleverTapControlAction.RecordEvent,
        oneOf: actionOptions,
      },
    },
    allOf: [
      {
        if: {
          properties: {
            operation: { const: CleverTapControlAction.RecordEvent },
          },
        },
        then: {
          type: 'object',
          properties: {
            eventName: {
              type: 'string',
            },
            eventProperties: {
              type: 'array',
              items: {
                type: 'object',
                properties: {
                  key: {
                    type: 'string',
                  },
                  value: {
                    type: 'string',
                  },
                },
              },
            },
          },
        },
      },
    ],
  };
};

export const getControlCleverTapUISchema = () => {
  const actionOptions = getCleverTapActionOptions();

  return {
    operation: {
      'ui:title': 'Operation',
      'ui:widget': 'GroupedSelectWidget',
      'ui:options': {
        'ua:enumIcons': actionOptions.map((option) => option.icon),
        'ua:enumGroup': actionOptions.map((option) => option.groupId),
      },
    },
    eventName: {
      'ui:title': 'Event Name',
      'ui:widget': 'VariableInputWidget',
      'ui:placeholder': 'e.g. Product Viewed, Add to Cart',
    },
    eventProperties: {
      'ui:field': 'KeyValuePairField',
      'ui:title': 'Event Properties',
      'ua:emptyState': {
        showEmptyPair: true,
      },
      items: {
        key: {
          'ui:placeholder': 'Property name',
          'ui:options': {
            title: 'Property',
          },
        },
        value: {
          'ui:placeholder': 'Property value',
        },
      },
    },
  };
};
